export const AVAILABLE_INTERESTS = [
  '🌲 Outdoors & Adventures',
  '💪 Fitness & Wellness',
  '🎨 Art & Creative Stuff',
  '🎭 Shows, Movies & Fun',
  '🎶 Music & Festivals',
  '🎮 Gaming & Board Games',
  '🏟️ Sports & Events',
  '🧠 Learn Something New',
  '🗣️ Meetups & Socials',
  '🤝 Volunteering & Good Vybes',
  '👗 Fashion & Style',
  '💻 Tech & Gadgets',
  '📚 Books & Chill',
  '🐶 Pets & Animals',
  '💃 Dance & Movement',
  '✈️ Travel & Trips'
] as const;

export type Interest = typeof AVAILABLE_INTERESTS[number];
